import * as E from "fp-ts/Either";
import * as R from "fp-ts/Reader";
import * as RTE from "fp-ts/ReaderTaskEither";
import * as TE from "fp-ts/TaskEither";
import { flow, pipe } from "fp-ts/function";
/**
 * @deprecated since 6.0.0
 * Use `of` from `fp-ts/ReaderTaskEither`
 */
export const of = (a) => RTE.of(a);
export const unit = RTE.of(undefined);
/**
 * @deprecated since 6.0.0
 * Use `asks` from `fp-ts/ReaderTaskEither`
 */
export const using = (g) => RTE.asks(g);
export const usingOf = (g) => (r) => g(r)(r);
/**
 * @deprecated since 6.0.0
 * Use `local` from `fp-ts/Reader`
 */
export const local = (g, app) => R.local(g)(app);
export const recoverOf = (g, app) => pipe(app, RTE.orElse(flow(g, E.right, RTE.fromEither)));
export const recover = (g, app) => pipe(app, RTE.orElse(g));
/**
 * @deprecated since 6.0.0
 * Use `left` from `fp-ts/ReaderTaskEither`
 */
export const fail = (e) => RTE.left(e);
/**
 * @deprecated since 6.0.0
 * Use `left` from `fp-ts/ReaderTaskEither`
 */
export const except = (e) => RTE.left(e);
/**
 * @deprecated since 6.0.0
 * Use `map` from `fp-ts/ReaderTaskEither`
 */
export const map = (g, app) => RTE.map(g)(app);
/**
 * @deprecated since 6.0.0
 * Use `fromEither` from `fp-ts/ReaderTaskEither`
 */
export const fromEither = (e) => RTE.fromEither(e);
/**
 * @deprecated since 6.0.0
 * Use `fromMaybe` from `fp-ts/ReaderTaskEither`
 */
export const fromMaybe = (m, e) => RTE.fromOption(() => e)(m);
/**
 * @deprecated since 6.0.0
 * Use `ap` from `fp-ts/ReaderTaskEither`
 */
export const ap = (appf, appv) => RTE.ap(appv)(appf);
/**
 * @deprecated since 6.0.0
 * Use `chain` from `fp-ts/ReaderTaskEither`
 */
export const chain = (g, app) => RTE.chain(g)(app);
/**
 * @deprecated since 6.0.0
 * Use `flatten` from `fp-ts/ReaderTaskEither`
 */
export const join = (app) => RTE.flatten(app);
export const fromPromise = (p, g) => RTE.fromTaskEither(TE.tryCatch(p, g));
export const run = (app) => (r) => app(r)();
/**
 * @deprecated since 6.0.0
 * Use `run`
 * Unwrap a App monad computation.
 *
 * @typeparam R Capabilities.
 * @typeparam E Exception.
 * @typeparam A Payload.
 */
export const runApp = (app) => run(app);

